exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/claudio/Projects/thebatclaudio.github.io/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/home/claudio/Projects/thebatclaudio.github.io/node_modules/postcss-loader?{"ident":"postcss"}!/home/claudio/Projects/thebatclaudio.github.io/src/app/menu-component/css/768.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/app/menu-component/css/768.css
// module chunks = main